import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';

import SectionTitle from '../SectionTitle/SectionTitle';
import ProgramFormRegistration from '../ProgramFormRegistration/ProgramFormRegistration';
import './SingleProgram.css';

export default class SingleProgram extends Component {

    state = {
        showRegistrationForm: null
    };

    handelModal = (id) => {
        this.setState({ showRegistrationForm: id })
    }

    closeModal = () => {
        this.setState({ showRegistrationForm: null });
    }

    renderProgram = (index) => {
        const {programClassName, programLists, SignUpBtn } = this.props.program
        // to display two colmun at a time - the current and previous item
        let program = [programLists[index - 1], programLists[index]];

        // console.log(program);
        if (programLists[index - 1] !== undefined) {
            return (
                <div className="columns is-flex mt-4 is-centered flex-dir-mobile" key={index} >
                    {
                        program.map((programList, i) => {
                            const model = <ProgramFormRegistration id={programList.programPathNumber} parentState={this.state.showRegistrationForm} closeModal={this.closeModal}  />

                            // console.log(programList);
                            const myModel = Object.assign({}, model);

                            return (
                                <div className="column is-4 mt-3" key={i}>
                                    <div className={`${programClassName} card`}>
                                        <div className="card-path">
                                            <div className="card-path-title is-flex">
                                                <h6> {programList.programPathLabel} </h6>
                                                <span>{programList.programPathNumber}</span>
                                            </div>
                                        </div>
                                        <div className="card-header-title is-centered">
                                            <h4 className="title is-5">{programList.programPathTitle}</h4>
                                        </div>
                                        <div className="card-content mt-1">
                                            <ul>
                                                {programList.programPathList.map((list, i) => {
                                                    return (
                                                        <li key={i}> {list} </li>
                                                    )
                                                })}
                                            </ul>
                                        </div>
                                        <div className="card-footer">
                                            <img src={SignUpBtn} alt="sign up"
                                                onClick={() => this.handelModal(programList.programPathNumber)} />
                                        </div>
                                    </div>
                                        {myModel}
                                </div>
                            );
                        })
                    }
                </div>
            );
        }
    }

    render() {
        // console.log(this.myModel);
        // console.log(this.model);

        const { programId, programLogo, programDescription, programLists,programPathTitle } = this.props.program
        // console.log(programLists[0].programPathLabel);
        return (
            <section id={programId} className="section">
                 <Fade>
                <SectionTitle>مسارات البرنامج</SectionTitle>
                </Fade>

                <div className="columns is-flex mt-4 is-centered flex-dir-mobile">
                    <div className="column is-3">
                        <div className="header-logo">
                            <img src={programLogo} alt={programPathTitle} />
                        </div>
                    </div>
                    <div className="column is-4 is-flex">
                        <p className="header-p"> {programDescription} </p>
                    </div>
                </div>

                {programLists.map((program, index) => {
                    return (
                        (index % 2) ?
                            this.renderProgram(index) : ''
                    )
                })}



            </section >
        )
    }
}